import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageHeader } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { DISPLAY_MODE } from "Constants";
import {
  createComponentStore,
  useStoreActions,
  useStoreState,
} from "easy-peasy";
import FourOThree from "Pages/private/403";
import FourOFour from "Pages/private/404";
import React, { useEffect, useState } from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import {
  RentableAreaStoreModel,
  ACTION_TYPES,
} from "store/models/master-data/rentable-area";
import { fixDates, GenerateBackPath } from "Utils";
import RentableAreaForm from "../components/form";

const useStore = createComponentStore(RentableAreaStoreModel);

export default function EditRentableAreaPage({ ...props }) {
  const { id } = useParams();
  const history = useHistory();
  const match = useRouteMatch();

  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.WRITE,
    "Kiralanabilir Alanlar"
  );
  const { updateBreadcrumb } = useStoreActions((store) => store.app);
  const [store, actions] = useStore();

  const [rentableArea, setRentableArea] = useState({
    address: null,
    allocationType: null,
    code: null,
    description: null,
    flat: null,
    floor: null,
    hardwares: [],
    measures: [],
    realEstate: null,
    rentableAreaType: null,
    subUnit: null,
    taskDistinctionTitle: null,
    version: 0,
  });

  useEffect(() => {
    if (id && AuthCheck(abilities, AUTH_ACTIONS.READ, "Kiralanabilir Alanlar"))
      actions.fetchSingle({ id: id });
  }, [id]);

  useEffect(() => {
    if (store.record) {
      updateBreadcrumb({
        object: {
          name: `${store.record.rentableAreaType.description} - ${store.record.description}`,
          path: match.path,
        },
        index: 2,
      });

      let payload = fixDates(store.record);
      payload.unit = payload.subUnit?.unit;
      setRentableArea(payload);
    }
  }, [store.record]);

  return store.process === ACTION_TYPES.FINISHED && !store.record ? (
    <FourOFour />
  ) : (
    <>
      <PageHeader
        className="customized"
        backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
        onBack={() => {
          history.push(GenerateBackPath(match.path, 4));
        }}
        title={`${
          store.process === ACTION_TYPES.FETCHING_DATA
            ? "Yükleniyor"
            : IsAuthorized
            ? `${store.record?.rentableAreaType.description} - ${store.record?.description}`
            : "Erişim Engellendi"
        }

        `}
      />
      {IsAuthorized ? (
        <RentableAreaForm
          mode={DISPLAY_MODE.EDIT}
          rentableArea={rentableArea}
          onAfterSuccess={(response) => {
            history.push(
              `${GenerateBackPath(match.path, 4)}/${response?.id}/detay`
            );
          }}
        />
      ) : (
        <FourOThree />
      )}
    </>
  );
}
